import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CoreUiModule } from '../core-ui/core-ui.module';
import { NewTablesModule } from '../core-ui/NewTable/NewTable.module';
import { ThirdPartyAccessModalComponent } from './ThirdPartyAccessEnableModal.component';
import { ThirdPartyUsersTableComponent } from './ThirdPartyUsersTable.component';

@NgModule({
    imports: [CommonModule, FormsModule, CoreUiModule, NewTablesModule],
    declarations: [
        ThirdPartyUsersTableComponent,
        ThirdPartyAccessModalComponent
    ],
    exports: [ThirdPartyUsersTableComponent, ThirdPartyAccessModalComponent]
})
export class ThirdPartyModule {}
